import { Service } from '@angular/core';

import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Service()
export class DateParserFormatterService extends NgbDateParserFormatter {
	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split('/');
			return {
				day: Number.parseInt(date[0], 10),
				month: Number.parseInt(date[1], 10),
				year: Number.parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? `${date.day}/${date.month}/${date.year}` : '';
	}
}
